import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { MatDialog } from '@angular/material';
import { LearnerService } from 'src/app/services/learner.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-portfolio-policy',
  templateUrl: './portfolio-policy.component.html',
  styleUrls: ['./portfolio-policy.component.scss']
})
export class PortfolioPolicyComponent implements OnInit {

  appealsProcedureForm;
  yourRightToAppealForm;
  equalOppForm;
  confirmationSign;
  showAppealsPro: boolean;
  showRightToAppeal: boolean;
  showEqualOpp: boolean;
  loading: boolean = false
  @Input('learnerObj') learnerObj;
  @Output() policyResposne: EventEmitter<any> = new EventEmitter<any>();
  learnerId: any;
  showInfo: boolean = true;
  infoForm: FormGroup;
  assessmentPlan: FormGroup;
  assessmentSign: any;
  showAssessmentPlan: boolean;
  assesmentSignError: boolean = false;
  showSignErr: boolean = false
  address;
  jobId
  constructor(public formBuilder: FormBuilder, public dialog: MatDialog, public _learnerService: LearnerService
    , public activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    console.log("learnerObj", this.learnerObj);

    this.activatedRoute.params.subscribe(param => {

      this.learnerId = param.id
    })
    this.activatedRoute.queryParams.subscribe(qparams => {
      if (qparams.job) {
        this.jobId = qparams.job
      }
    })

    this.createForm()
  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log('learnerObj from learner dashboard', changes);
    if (changes.learnerObj && changes.learnerObj.currentValue) {
      this.learnerObj = changes.learnerObj.currentValue
      console.log("what is the value of learner", this.learnerObj);
      this.createForm()
      // this.getSessions()
    }
  }

  createForm(details?) {
    console.log("details-------->", details);

    this.appealsProcedureForm = new FormGroup({
      sign: new FormControl((details && details.appealsProcedureForm) ? details.appealsProcedureForm.sign : '', Validators.required),
      confirmDate: new FormControl((details && details.appealsProcedureForm) ? details.appealsProcedureForm.sign : '', Validators.required)
    })

    this.yourRightToAppealForm = new FormGroup({
      sign: new FormControl((details && details.yourRightToAppealForm) ? details.yourRightToAppealForm.sign : '', Validators.required),
      confirmDate: new FormControl((details && details.yourRightToAppealForm) ? details.yourRightToAppealForm.confirmDate : '', Validators.required)
    })

    this.equalOppForm = new FormGroup({
      sign: new FormControl((details && details.equalOppForm) ? details.equalOppForm.sign : '', Validators.required),
      confirmDate: new FormControl((details && details.equalOppForm) ? details.equalOppForm.confirmDate : '', Validators.required)
    })

    this.infoForm = new FormGroup({
      address: new FormControl((details && details.infoForm) ? details.infoForm.address : '', Validators.required),
      candidateName: new FormControl(this.learnerObj && this.learnerObj.name ? this.learnerObj.name : '', Validators.required),
      candidateRegNo: new FormControl((details && details.infoForm) ? details.infoForm.candidateRegNo : '', Validators.required),
      assessorName: new FormControl((details && details.infoForm) ? details.infoForm.assessorName : '', Validators.required),
      IQAName: new FormControl((details && details.infoForm) ? details.infoForm.IQAName : '', Validators.required),
    })

    this.assessmentPlan = new FormGroup({
      location: new FormControl((details && details.assessmentPlan) ? details.assessmentPlan.location : '', Validators.required),
      candidateSign: new FormControl((details && details.assessmentPlan) ? details.assessmentPlan.candidateSign : '', Validators.required),
      assessmentDate: new FormControl((details && details.assessmentPlan) ? details.assessmentPlan.assessmentDate : '', Validators.required)
    })
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'assessmentPlan')
      this.assessmentPlan.get(formControl).setValue(value);

    else if (formGroup == 'appealsProcedureForm')
      this.appealsProcedureForm.get(formControl).setValue(value);

    else if (formGroup == 'yourRightToAppealForm')
      this.yourRightToAppealForm.get(formControl).setValue(value);

    else if (formGroup == 'equalOppForm')
      this.equalOppForm.get(formControl).setValue(value);

  }

  redirect(role) {
    // this.router.navigateByUrl('/signature')
    this.openDialog(SignaturePadComponent).subscribe(data => {
      console.log("roel => ", role)
      console.log("data from signature", data)
      this.confirmationSign = data
      if (role == 'appeals') {
        this.showSignErr = false
        this.appealsProcedureForm.patchValue({
          sign: this.confirmationSign
        })
        // this.confirmationSign = null
      }
      else if (role == 'rightToAppeal') {
        this.showSignErr = false
        this.yourRightToAppealForm.patchValue({
          sign: this.confirmationSign
        })
        // this.confirmationSign = null
      }

      else if (role == 'equalOpp') {
        this.showSignErr = false
        this.equalOppForm.patchValue({
          sign: this.confirmationSign
        })
        // this.confirmationSign = null
      }
      else if (role == 'assessment') {
        this.assessmentSign = data
        this.showSignErr = false
        this.assessmentPlan.patchValue({
          candidateSign: this.assessmentSign
        })
        // this.confirmationSign = null
      }

    })
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }
  afterInfo() {
    if (this.infoForm.valid) {
      this.showInfo = false
      this.showAssessmentPlan = true
      this.confirmationSign = null
    } else {
      this.infoForm.markAllAsTouched()
    }
  }
  afterAssessmentPlan(direction) {
    if (direction == 'next') {
      if (this.assessmentPlan.valid && this.assessmentSign) {
        this.showSignErr = false
        this.showAssessmentPlan = false
        this.showAppealsPro = true
        this.confirmationSign = this.appealsProcedureForm.get('sign').value
        console.log("this.confirmationSign in afterAssessmetPlan", this.confirmationSign)
      } else {
        if (!this.assessmentSign) {
          this.showSignErr = true
        }
        this.assessmentPlan.markAllAsTouched()
      }
    } else {
      this.showAssessmentPlan = false;
      this.showInfo = true
    }

  }
  afterAppealsPro(direction) {
    if (direction == 'next') {
      if (this.appealsProcedureForm.valid && this.confirmationSign) {
        this.confirmationSign = null
        this.showAppealsPro = false
        this.showSignErr = false
        this.showRightToAppeal = true
        this.confirmationSign = this.yourRightToAppealForm.get('sign').value
      } else {
        if (!this.confirmationSign) {
          this.showSignErr = true
        }
        console.log("this.appealsProcedureForm", this.appealsProcedureForm)
        this.appealsProcedureForm.markAllAsTouched()
      }
    } else {

      this.showAppealsPro = false
      this.showAssessmentPlan = true
      this.confirmationSign = this.appealsProcedureForm.valid ? 'done' : null
      console.log("this.confirmationSign on back", this.confirmationSign)
    }
  }

  afterRightToAppeal(direction) {
    if (direction == 'next') {
      if (this.yourRightToAppealForm.valid) {
        this.confirmationSign = null
        this.showRightToAppeal = false
        this.showEqualOpp = true
        this.confirmationSign = this.equalOppForm.get('sign').value
      } else {
        if (!this.yourRightToAppealForm.value.sign) {
          this.showSignErr = true;
        }
        this.yourRightToAppealForm.markAllAsTouched()
      }
    } else {
      this.confirmationSign = this.appealsProcedureForm.valid ? 'done' : null
      console.log("this.confirmationSign on back", this.confirmationSign)
      this.showRightToAppeal = false
      this.showAppealsPro = true
    }

  }

  back() {
    this.showRightToAppeal = true
    this.showEqualOpp = false
    this.confirmationSign = this.yourRightToAppealForm.get('sign').value
  }

  submit() {

    if (this.equalOppForm.valid) {
      this.infoForm.patchValue({
        candidateName: this.learnerObj.name
      })
      this.infoForm.updateValueAndValidity()
      this.showSignErr = false
      this.loading = true;
      let data = {
        learnerId: this.learnerId,

        jobId: this.jobId,
        version: false
      }
      let details = {
        policy: {
          appeals: this.appealsProcedureForm.value,
          right: this.yourRightToAppealForm.value,
          equality: this.equalOppForm.value,
          policyAccept: true,
        },
        info: this.infoForm.value,
        assessmentPlan: this.assessmentPlan.value,
      }
      data['details'] = details
      console.log("this._learnerService.submitPolicy(data)", data)
      this._learnerService.submitPolicy(data).subscribe(res => {
        console.log('Policy res', res);
        this.policyResposne.emit({ policyAccepted: true })
        this.loading = false

      }, (err) => {
        this.policyResposne.emit({ policyAccepted: false })
        this.loading = false

        console.log("policy not accepted", err)
      })
    }
    else {
      if (!this.equalOppForm.value.sign) {
        this.showSignErr = true;
      }
      this.equalOppForm.markAllAsTouched()

    }


    // console.log('FORMS',data);

  }

}
// @232
// [(ngModel)]="consentEdit && consentEdit.confirm ? consentEdit.confirm.confirmDate : ''"